import React, { useState } from "react";
import Styles from "./styles.module.scss";
import H2 from "../../../../components/typography/h2";
import H3 from "../../../../components/typography/h3";
import bannerimg from "../../../../assets/newhomepageimg/360view/bannerimg.webp";
import serviceimage1 from "../../../../assets/newhomepageimg/360view/serviceimg1.webp";
import serviceimage2 from "../../../../assets/newhomepageimg/360view/serviceimg2.webp";
import serviceimage3 from "../../../../assets/newhomepageimg/360view/serviceimg3.webp";
import serviceimage4 from "../../../../assets/newhomepageimg/performancemarketing/servicesimg4.svg";
import { FaPlus, FaMinus } from "react-icons/fa";
import Processimg from "../../../../assets/newhomepageimg/performancemarketing/processimg.webp"

const Photography360view = () => {

 const [activeIndex, setActiveIndex] = useState<number | null>(null);
const [activeFaq, setActiveFaq] = useState<number | null>(null);

const toggleAccordion = (index: number) => {
  setActiveIndex(index === activeIndex ? null : index);
};

  const services = [
    {
      title: "Videography",
      description:
        "Put viewers in the center with dynamic 360° videos that offer full perspective and real impact.",
      image: serviceimage1,
    },
    {
      title: "Photography",
      description:
        "Capture your space from every angle with stunning, high-resolution 360° photography.",
      image: serviceimage2,
    },
    {
      title:"Virtual Tours",
      description:
        "Our virtual tours give viewers the freedom to navigate your space at their own pace, creating a truly immersive experience.",
      image: serviceimage3,
    },
   
    // {
    //   title: "Graphic Designing",
    //   description:
    //     "We help your brand stay stylish and engaging with eye-catching graphics through creative concept execution.",
    //   image: serviceimage5,
    // },
    // {
    //   title: "Posting & Scheduling",
    //   description:
    //     "We help your brand stay visible and on-time with scheduled posts and optimal timing through planning.",
    //   image: serviceimage6,
    // },
  ];

  const accordionData = [
    {
      title: "Strategy & Planning",
      content:
        "We create eye-catching display ads that boost visibility and drive traffic across websites and apps. With smart targeting and compelling visuals, we help your brand stay top-of-mind.",
    },
    {
      title: "Audience & Targeting",
      content:
        "We craft engaging video ads that capture attention and tell your brand story. From short reels to YouTube campaigns, we help you connect with your audience through impactful visuals.",
    },
    {
      title: "Creative & Copy Writing",
      content: "We run targeted campaigns to drive high-quality app installs and in-app conversions. By reaching the right users at the right time, we help you grow and retain your app audience efficiently.",
    },
    {
      title: "Optimization & Management",
      content:
        "We design and run high-converting campaigns that boost product visibility and drive online sales. From seasonal promotions to retargeting, we help e-commerce brands grow faster.",
    },
        {
      title: "Reporting & Analysis",
      content:
        "We design and run high-converting campaigns that boost product visibility and drive online sales. From seasonal promotions to retargeting, we help e-commerce brands grow faster.",
    },
        {
      title: "Continuous Learning",
      content:
        "We design and run high-converting campaigns that boost product visibility and drive online sales. From seasonal promotions to retargeting, we help e-commerce brands grow faster.",
    },
  ];


const faqData = [
  {
    question: "WWhat is 360° photography, and how does it work?",
    answer: "Digital marketing promotes your business online using tools like social media, SEO, and email to increase visibility and sales."
  },
  {
    question: "How long does a 360° shoot take?",
    answer: "You may start seeing early signs in 1-3 months, but significant ROI usually builds over 3–6 months."
  },
  {
    question: "Can 360° photography help my business attract more customers?",
    answer: "Yes, we provide regular performance updates with key metrics and next-step recommendations."
  },
  {
    question: "Is any special equipment required from my side?",
    answer: "We work with Instagram, Facebook, LinkedIn, Google Ads, YouTube, and more depending on your audience."
  },
];

  return (
    <>
      <div className="container">
        <div className={Styles.project_info}>
        <div className={Styles.breadcrumb}>
 <a href="/" ><span>
 Home
</span>
</a>
<span className={Styles.separator}>/</span>
 <span>
 Services
</span>
  <span className={Styles.separator}>/</span>
  <span className={Styles.active}>360° View Photography
</span>
</div>

          <div style={{ marginTop: "80px" }}>
            <H3>
              Next-Generation <span>360° View Photography</span> for Immersive Digital Showcases
            
              
            </H3>
          </div>
        </div>
      </div>

      <div className={Styles.bannerimg}>
        <img src={bannerimg} alt="bannerimg" />
      </div>

      <div className="container">
        <div className={Styles.strategysection}>
          <h1 className={Styles.heading}>
            Bring Your Space to Life with 
           {" "}
            <span className={Styles.highlight}>Every Angle Captured</span> 
          </h1>
          <p className={Styles.description}>
       At 360 View.ai, we specialize in turning real-world spaces into vivid, interactive digital experiences that captivate and inform. Through advanced 360° photography and intelligent AI-driven processing, we create immersive virtual tours that allow viewers to explore every corner of your property as if they were truly there. Whether you're in real estate, hospitality, retail, or design, our solutions provide a powerful way to showcase your space with clarity, depth, and emotion. Every angle is captured with precision, ensuring a seamless and engaging experience for clients, customers, or stakeholders. With 360 View.ai, your space becomes more than just a location—it becomes a story that’s seen, felt, and remembered.
          </p>
          <button className={Styles.ctaButton}>Let's Talk</button>
        </div>
      </div>

      <div className={Styles.bgservices}>
        <div className="container">
          <div className={Styles.servicesaln}>
            <div className={Styles.headergrid}>
              <p className={Styles.subTitlegrid}>Services We Provide</p>
              <h2 className={Styles.titlegrid}>
              
              Here’s {" "}
                <span className={Styles.highlightgrid}>what we offer</span>{" "}
                  to grow your <br />
              
brand through performance marketing.
              </h2>
              <p className={Styles.descriptiongrid}>
                We provide everything from branding and design to SEO and IT
                support ensuring your digital presence is seamless, effective,
                and future-ready.
              </p>
            </div>
            <div>
              <button className={Styles.ctaButton}>Let's Talk</button>
            </div>
          </div>
<div
  className={`${Styles.grid} ${
    services.length === 3 || services.length === 6 ? Styles.threeCols : Styles.twoCols
  }`}
>
  {services.map((service, idx) => (
    <div className={Styles.card} key={idx}>
      <img
        src={service.image}
        alt={service.title}
        className={Styles.imagegrid}
      />
      <h3 className={Styles.cardTitle}>{service.title}</h3>
      <p className={Styles.cardDescription}>{service.description}</p>
    </div>
  ))}
</div>
        </div>
      </div>

      <div className={Styles.processWrapper}>
        <div className="container">
          {/* Left Column */}
          <div className={Styles.servicesaln}>
            <div className={Styles.headergrid}>
              <p className={Styles.subTitlegrid}>Our Process</p>
              <h2 className={Styles.titlegrid}>This is how we turn ad spend

              {" "}<br/>into
                <span className={Styles.highlightgrid}>measurable growth </span>{" "}
                
 
              </h2>
              <p className={Styles.descriptiongrid}>
              We use strategy, creativity, and data to run campaigns that deliver results. Every step is focused on maximizing ROI and driving real growth.
              </p>
            </div>
            <div>
              <button className={Styles.ctaButton}>Let's Talk</button>
            </div>
          </div>
<div className={Styles.accordionSection}>

    <div className={Styles.accordionGrid}>
      {/* Left Side */}
      <div className={Styles.leftContent}>
        <img src={Processimg} alt="Social Media" className={Styles.accordionImage} />
        <div className={Styles.cardBoxx}>
          <p className={Styles.cardTitlee}>Want long-term traffic alongside paid results?</p>
          <p className={Styles.cardTextt}>
Our SEO helps you rank organically, so you keep getting leads even when ads pause.
          </p>
          <button className={Styles.cardButton}>Learn More</button>
        </div>
      </div>

      {/* Right Side - Accordion */}
      <div className={Styles.rightContent}>
        {accordionData.map((item, index) => (
          <div className={Styles.accordionItem} key={index}>
            <div
              className={Styles.accordionHeader}
              onClick={() => toggleAccordion(index)}
            >
              <h4>{item.title}</h4>
              <span>
  {activeIndex === index ? (
  <FaMinus />
) : (
 <svg width="28" height="28" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.0938 23.375H20.625V29.9062C20.625 30.0953 20.7797 30.25 20.9688 30.25H23.0312C23.2203 30.25 23.375 30.0953 23.375 29.9062V23.375H29.9062C30.0953 23.375 30.25 23.2203 30.25 23.0312V20.9688C30.25 20.7797 30.0953 20.625 29.9062 20.625H23.375V14.0938C23.375 13.9047 23.2203 13.75 23.0312 13.75H20.9688C20.7797 13.75 20.625 13.9047 20.625 14.0938V20.625H14.0938C13.9047 20.625 13.75 20.7797 13.75 20.9688V23.0312C13.75 23.2203 13.9047 23.375 14.0938 23.375Z" fill="#444444"/>
<path d="M37.8125 4.8125H6.1875C5.42695 4.8125 4.8125 5.42695 4.8125 6.1875V37.8125C4.8125 38.573 5.42695 39.1875 6.1875 39.1875H37.8125C38.573 39.1875 39.1875 38.573 39.1875 37.8125V6.1875C39.1875 5.42695 38.573 4.8125 37.8125 4.8125ZM36.0938 36.0938H7.90625V7.90625H36.0938V36.0938Z" fill="#444444"/>
</svg>

)}
              </span>
            </div>
            {activeIndex === index && (
              <div className={Styles.accordionContent}>
                <p>{item.content}</p>
              </div>
            )}
          </div>
        ))}
      </div>

    </div>
  </div>



      
         
        </div>
      </div>
      <div className={Styles.ctaBanner360view}>
  <div className={Styles.ctaOverlay}>
    <h2 className={Styles.ctaHeading}>
   Ready to Showcase Your Space

 <br />in Stunning 360°?
    </h2>
    <p className={Styles.ctaSubtext}>Create immersive virtual experiences that captivate your audience.</p>
    <button className={Styles.ctaButton}>Get Started Now</button>
  </div>
</div>
<div>

 
  <div className="container">
    <div className={Styles.faqGrid}>
      
      {/* Left: Title */}
      <div className={Styles.faqTitleBlock}>
        <p className={Styles.faqLabel}>F.A.Q</p>
        <h2 className={Styles.faqHeading}>
        Frequently Asked Questions<br/>
and Helpful Answers
        </h2>
      </div>

      {/* Right: Accordion */}
      <div className={Styles.faqAccordion}>
        {faqData.map((item, index) => (
          <div className={Styles.accordionItem} key={index}>
            <div
              className={Styles.accordionHeader}
              onClick={() => setActiveFaq(index === activeFaq ? null : index)}
   
            >
              <h4>{item.question}</h4>
              <span>{activeFaq === index ? (
  <FaMinus />
) : (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.6875 12.75H11.25V16.3125C11.25 16.4156 11.3344 16.5 11.4375 16.5H12.5625C12.6656 16.5 12.75 16.4156 12.75 16.3125V12.75H16.3125C16.4156 12.75 16.5 12.6656 16.5 12.5625V11.4375C16.5 11.3344 16.4156 11.25 16.3125 11.25H12.75V7.6875C12.75 7.58437 12.6656 7.5 12.5625 7.5H11.4375C11.3344 7.5 11.25 7.58437 11.25 7.6875V11.25H7.6875C7.58437 11.25 7.5 11.3344 7.5 11.4375V12.5625C7.5 12.6656 7.58437 12.75 7.6875 12.75Z" fill="#444444"/>
    <path d="M20.625 2.625H3.375C2.96016 2.625 2.625 2.96016 2.625 3.375V20.625C2.625 21.0398 2.96016 21.375 3.375 21.375H20.625C21.0398 21.375 21.375 21.0398 21.375 20.625V3.375C21.375 2.96016 21.0398 2.625 20.625 2.625ZM19.6875 19.6875H4.3125V4.3125H19.6875V19.6875Z" fill="#444444"/>
  </svg>
)}</span>
            </div>
            {activeFaq === index && (
              <div className={Styles.accordionContent}>
                <p>{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>

    </div>
  </div>


</div>
    </>
  );
};

export default Photography360view;